export default "__VITE_ASSET__BlaZewfU__"